import axios from 'axios';
import Authenticator from '../authenticator';
import { useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Table, Button, Row, Col, Form, Badge, Dropdown } from 'react-bootstrap';
import Loading from '../components/loading';
import ErrorMessage from '../components/errorMessage';
import { Link } from 'react-router-dom';
import paths from '../../../routes/paths';
import api from '../api/api';

export default function ClientList() {

  const [clients, setClients] = useState([]);
  const [linkedUsers, setLinkedUsers] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = () => {
    setIsLoading(true);
    api.get('/clients', {
      headers: { Authorization: sessionStorage.getItem('token') }
    }).then((returnFromApi) => {
      setClients(returnFromApi.data);
      setIsLoading(false);
    }).catch((error) => {
      console.error(error);
      setIsLoading(false);
    });
  };

  function findUsersFromClient(clientId) {
    setIsLoading(true);
    setSelectedClientId(clientId);
    api.get(`/users/clients/${clientId}`, {
      headers: { Authorization: sessionStorage.getItem('token') }
    }).then((returnFromApi) => {
      setLinkedUsers(returnFromApi.data);
      setIsLoading(false);
    }).catch((error) => {
      console.error(error);
      setIsLoading(false);
    });
  };

  return (
    <div style={{ minHeight: '500px' }}>
      <Authenticator />
      {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}
      <Loading isToHidden={!isLoading} />

      <Row className="g-3">
        <Col lg={7} xl={8}>
          <Card className="h-100 bg-transparent-50">
            <CardHeader className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0 texto-negrito">Listagem de Clientes</h5>
              <Link to={paths.clientRegistration}>
                <Button variant="primary" size="sm">
                  Cadastrar Cliente
                </Button>
              </Link>
            </CardHeader>

            <CardBody className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0 align-middle">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Data de Criação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clients.map((client) => (
                      <tr
                        key={client.id}
                        className={selectedClientId === client.id ? 'table-active' : ''}
                        onClick={() => findUsersFromClient(client.id)}
                      >
                        <td className="fw-semi-bold">{client.name}</td>
                        <td>{client.createdAt || ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col lg={5} xl={4}>
          <Card className="h-100 bg-transparent-50">
            <CardHeader className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0 texto-negrito">Usuários Vinculados</h5>
              <Link to={paths.userRegistration}>
                <Button variant="primary" size="sm">
                  Cadastrar Usuário
                </Button>
              </Link>
            </CardHeader>
            <CardBody className="p-0">

              {!selectedClientId && (
                <div className="text-center p-4 text-muted">
                  Selecione um cliente ao lado para ver os usuários.
                </div>
              )}

              {selectedClientId && linkedUsers.length === 0 && (
                <div colSpan="3" className="text-center py-4 text-muted">
                  Nenhum usuário vinculado a este cliente.
                </div>
              )}

              <div className="table-responsive" hidden={linkedUsers.length === 0}>
                <Table hover className="mb-0 align-middle">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Login</th>
                    </tr>
                  </thead>
                  <tbody>
                    {linkedUsers.map((user) => (
                      <tr key={user.id}>
                        <td>
                          <div className="avatar avatar-s me-2"></div>
                          {user.name}
                        </td>
                        <td className="fs--1 text-600">{user.login}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}